import { BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseContainerService } from 'yt-ng-framework';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Zanimanje } from './zanimanje';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-zanimanje-update',
  templateUrl: './zanimanje-update.component.html'
})
export class ZanimanjeUpdateComponent 
extends BaseUpdateComponent<Zanimanje> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'ZANIMANJE.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(100), 'maxlength', 'ZANIMANJE.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Sifra", Validators.required, 'required', 'ZANIMANJE.SIFRA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Sifra", Validators.maxLength(6), 'maxlength', 'ZANIMANJE.SIFRA.VALIDATION.MAXLENGTH');
  }

  
}
